<textarea
  #textarea
  autocomplete="off"
  [readonly]="readonly"
  [id]="id"
  [class.error]="error"
  [class.warning]="warning"
  [disabled]="disabled"
  (ngModelChange)="_onChange($event)"
  (focus)="_onFocus()"
  (blur)="_onBlur()"
  [ngModel]="value"
  [attr.placeholder]="placeholder | translate"
  class="myre-form__field"
  required
  [attr.rows]="rows"
  [attr.cols]="cols"
>
  {{ value }}
</textarea>
